// Delay for Onboarding when there's transitions (i.e. opening/expanding/closing the hud) (in milliseconds)
export const OnboardingDelayWithTransitions = 1800;
// Delay for Onboarding when there's no transitions
export const OnboardingDelayWithoutTransitions = 500;



// WEBPACK FOOTER //
// ./src/constants/app.js